import React from "react";
import { useRecoilValue } from "recoil";
import { enlargeAvatarData } from "../../atoms/avatar";
import EnlargedUserAvatar from "./EnlargedUserAvatar";

const UserAvatarPortal = () => {
    const enlargeAvatarAtom = useRecoilValue(enlargeAvatarData);

    if (!enlargeAvatarAtom) {
        return null;
    }

    return <EnlargedUserAvatar {...enlargeAvatarAtom} />;
};

export default UserAvatarPortal;
